const CLINIC_PROVIDER_ALERT = {
    LAB_RADIOLOGY_BUNDLE:
        "Lab and radiology items are not selectable for the clinic's default provider.",
    LAB_RADIOLOGY:
        "Estimate that contain lab/radiology item cannot be clinic default provider. Please select a different provider."
};

export default {
    CLINIC_PROVIDER_ALERT
};
